/** @format */

export default {
  root: {
    backgroundColor: '#fff',
    '&$selected': {
      color: '#2B3990',
    },
  },
  textColorInherit: {
    color: '#546e7a',
  },

};
